// eslint-disable-next-line no-unused-vars
class BookmarkComponent {
  constructor(
    $element,
    ajaxUrl,
    fetchStatusAction,
    addAction,
    deleteAction,
  ) {
    this.$element = $element;
    this.postId = $element.data('postid');
    this.postType = $element.data('posttype');
    this.labelSave = '';
    this.labelSaved = '';
    this.elementLocked = false;
    this.initialized = false;
    this.ajaxUrl = ajaxUrl;
    this.fetchStatusAction = fetchStatusAction;
    this.addAction = addAction;
    this.deleteAction = deleteAction;
  }

  init() {
    const self = this;

    this.$element.html('<span class="u-sr-only">Leeslijst status ophalen</span>');
    const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z" fill="currentColor" /></svg>';
    this.$element.append(svgIcon);
    this.$element.prop('disabled', true);
    
    this.fetchBookmarkStatus(() => { self.initBookmarkStatusListeners(); });
    this.setLabel();

    this.initialized = true;
  }

  setLabel() {
    const self = this;

    self.labelSave = 'Bewaar bericht';
    self.labelSaved = 'Bericht bewaard';

    if (this.postType === 'planten') {
      self.labelSave = 'Bewaar plant';
      self.labelSaved = 'Plant bewaard';
    }

  }


  fetchBookmarkStatus(callback) {
    const url = `${this.ajaxUrl}?action=${this.fetchStatusAction}`;
    const self = this;
    // fetch status
    self.lockElement();
    $.post(url, { postId: self.postId }, (result) => {
      self.updateBookmarkElement(result);
      if (callback) {
        callback();
      }
    }).fail((data) => { 
      if (data.status === 401) {
        // Not logged in
        this.changeButtonToAnchorWhenNotLoggedin();
      }
    }).always(() => {
      self.releaseElement();
    });
  }

  changeButtonToAnchorWhenNotLoggedin() {
    const self = this;
    self.$element.html(`<span>${this.labelSave}</span>`);
    const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z" fill="currentColor" /></svg>';
    self.$element.append(svgIcon);
    const dataUrl = self.$element.data('url');
    let toolTip = dataUrl ? `<span class="c-button__tooltip"><a href="${dataUrl}" class="c-button__tooltip-link">Log in</a>` : `<span class="c-button__tooltip">Log in`;
    toolTip += ` of maak een gratis account aan.</span>`;
    self.$element.append(toolTip);

    const anchorElement = $('<div>', {
      class: self.$element.attr('class'),
      html: self.$element.html(),
    });
    self.$element.replaceWith(anchorElement);
    self.$element = anchorElement;
    return self;
  }

  updateBookmarkElement(data) {
    const labelText = data.active ? this.labelSaved : this.labelSave;
    const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z" fill="currentColor" /></svg>';

    const applyStateToElement = ($el) => {
      $el.html(`<span>${labelText}</span>`);
      $el.append(svgIcon);
      $el.data('status', data.active ? 'active' : 'inactive');
      $el.data('uuid', data.uuid);
    };

    // Update clicked element
    applyStateToElement(this.$element);

    // Sync other instances for same post on the page
    $(`.c-bookmark-status[data-postid="${this.postId}"]`).each((_, el) => {
      const $el = $(el);
      if ($el[0] !== this.$element[0]) {
        applyStateToElement($el);
      }
    });
  }

  initBookmarkStatusListeners() {
    const self = this;
    this.$element.prop('disabled', false);
    this.$element.on('click', function () {
      if (self.elementLocked) {
        return;
      }
      switch ($(this).data('status')) {
        case 'active':
          self.deleteBookmark(self.$element.data('uuid'));
          break;
        case 'inactive':
          self.addBookmark();
          break;
        default:
          self.fetchBookmarkStatus();
      }
    });
  }

  deleteBookmark(uuid) {
    const url = `${this.ajaxUrl}?action=${this.deleteAction}`;
    const self = this;
    self.lockElement();
    $.post(url, { postId: self.postId, bookmarkId: uuid }, (result) => {
      self.updateBookmarkElement(result);
    }).always(() => {
      self.releaseElement();
    });
  }

  addBookmark() {
    const url = `${this.ajaxUrl}?action=${this.addAction}`;
    const self = this;

    self.lockElement();
    $.post(url, { postId: self.postId }, (result) => {
      self.updateBookmarkElement(result);
    }).always(() => {
      self.releaseElement();
    });
  }

  lockElement() {
    this.elementLocked = true;
    this.$element.addClass('fetching-bookmark-status');
    this.$element.prop('disabled', true);
  }

  releaseElement() {
    this.$element.removeClass('fetching-bookmark-status');
    this.$element.prop('disabled', false);
    this.elementLocked = false;
  }
}
